var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
      _c("span", [_vm._v("Client Information")]),
    ]),
    _c("div", { staticClass: "ca-form" }, [
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Name" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50", placeholder: "Short Name" },
                model: {
                  value: _vm.value.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "name", $$v)
                  },
                  expression: "value.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Address" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50", placeholder: "Company Address" },
                model: {
                  value: _vm.value.address,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "address", $$v)
                  },
                  expression: "value.address",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Company" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50", placeholder: "Company Name" },
                model: {
                  value: _vm.value.company,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "company", $$v)
                  },
                  expression: "value.company",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "City" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50", placeholder: "Company City" },
                model: {
                  value: _vm.value.city,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "city", $$v)
                  },
                  expression: "value.city",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Phone" } },
            [
              _c("el-input", {
                attrs: { maxlength: "100", placeholder: "(123) 456-1000" },
                model: {
                  value: _vm.value.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "phone", $$v)
                  },
                  expression: "value.phone",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "State" } },
            [
              _c("el-input", {
                attrs: {
                  width: "100px",
                  maxlength: "10",
                  placeholder: "State",
                },
                model: {
                  value: _vm.value.state,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "state", $$v)
                  },
                  expression: "value.state",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Email Address" } },
            [
              _c("el-input", {
                attrs: { maxlength: "200", placeholder: "Email Address" },
                model: {
                  value: _vm.value.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "email", $$v)
                  },
                  expression: "value.email",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Zip" } },
            [
              _c("el-input", {
                attrs: { width: "100px", maxlength: "20" },
                model: {
                  value: _vm.value.postalCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "postalCode", $$v)
                  },
                  expression: "value.postalCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            {
              staticClass: "w-50",
              attrs: { label: "Notification Email Address" },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "200",
                  placeholder: "Notification Address",
                },
                model: {
                  value: _vm.value.notificationEmail,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "notificationEmail", $$v)
                  },
                  expression: "value.notificationEmail",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "API Name" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50", placeholder: "API Name" },
                model: {
                  value: _vm.value.apiName,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "apiName", $$v)
                  },
                  expression: "value.apiName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "API Token" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50", placeholder: "api-token" },
                model: {
                  value: _vm.value.apiToken,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "apiToken", $$v)
                  },
                  expression: "value.apiToken",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "API Client Name" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50", placeholder: "my-company" },
                model: {
                  value: _vm.value.apiClientName,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "apiClientName", $$v)
                  },
                  expression: "value.apiClientName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Outbound API URL" } },
            [
              _c("el-input", {
                attrs: { maxlength: "200", placeholder: "Outbound URL" },
                model: {
                  value: _vm.value.apiWebHookUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "apiWebHookUrl", $$v)
                  },
                  expression: "value.apiWebHookUrl",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }